import { render } from "./Footer.vue?vue&type=template&id=388bd1b9&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=388bd1b9&lang=less&scoped=true"

import exportComponent from "E:\\MyProject\\crash-webfrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388bd1b9"]])

export default __exports__